import React from "react";
import { motion } from "framer-motion";
import { useWallet } from "@/context/WalletContext";
import { Panel, Pill } from "@/components/croc/ui";
import { fmtUsd, pct } from "@/lib/format";
import { Link } from "react-router-dom";
import { Crown, Users, Wallet } from "lucide-react";

export const RankNudge = () => {
  const { user } = useWallet();
  const next = user?.next_rank;
  const cur = user?.rank;
  if (!user || !next) return null;
  const matching = user?.matching_volume ?? 0;
  const selfTopup = user?.self_topup ?? 0;
  const matchingLeft = Math.max(0, next.matching - matching);
  const selfLeft = Math.max(0, next.self_topup - selfTopup);
  const commGain = (next.commission_pct - (cur?.commission_pct ?? 0)) * 100;

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
      <Panel glow="gold" className="mb-6" data-testid="rank-nudge">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4 min-w-0">
            <div className="w-12 h-12 rounded-2xl bg-[#1CFD4C]/12 border border-[#1CFD4C]/30 grid place-items-center glow-gold shrink-0">
              <Crown className="w-6 h-6 gold-text" />
            </div>
            <div className="min-w-0">
              <div className="text-xs uppercase tracking-widest text-muted-foreground">Next Rank · {next.name}</div>
              <div className="font-display font-bold text-white text-sm sm:text-base" data-testid="rank-nudge-text">
                {matchingLeft > 0 ? (
                  <>You're <span className="gold-text font-num">{fmtUsd(matchingLeft)}</span> matching away from <span className="gold-text">{next.name}</span>
                    {next.one_time_reward > 0 && <> — and its <span className="emerald-text font-num">{fmtUsd(next.one_time_reward)}</span> reward</>}</>
                ) : selfLeft > 0 ? (
                  <>Matching done — top up <span className="gold-text font-num">{fmtUsd(selfLeft)}</span> more to unlock <span className="gold-text">{next.name}</span></>
                ) : (
                  <>Ready to promote to <span className="gold-text">{next.name}</span></>
                )}
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1.5 text-[11px] text-muted-foreground">
                <span className="flex items-center gap-1"><Users className="w-3 h-3" /> Matching {fmtUsd(matching)} / {fmtUsd(next.matching)}</span>
                <span className="flex items-center gap-1"><Wallet className="w-3 h-3" /> Self top-up {fmtUsd(selfTopup)} / {fmtUsd(next.self_topup)}</span>
                {commGain > 0 && <span className="emerald-text font-num">+{pct(commGain, 0)} commission on team rewards</span>}
              </div>
            </div>
          </div>
          <Link to="/ranks" data-testid="rank-nudge-link">
            <Pill tone="gold">View ranks →</Pill>
          </Link>
        </div>
      </Panel>
    </motion.div>
  );
};
